import React from 'react';
import { ToBillEvent } from '../../../models/Factura';
import { conceptoToTotales } from '../../../utils/calculate.conceptos';
import PreviewConceptos from './Preview.conceptos';
import PreviewTotales from './Preview.totales';

interface PreviewSecondaryBillsProps {
    toBillEvents: ToBillEvent[];
}

/** Nota de crédito and liquidación bills derived from an "adelanto" bill argument */
function PreviewSecondaryBills({ toBillEvents }: PreviewSecondaryBillsProps) {
    if (!toBillEvents) {
        return null;
    }
    return (
        <>
            {toBillEvents.map((billEvent, i) => {
                const notaTotales = conceptoToTotales(!!billEvent.NotaCreditoCFDI ? billEvent.NotaCreditoCFDI.conceptos : []);
                const cfdiTotales = conceptoToTotales(!!billEvent.CFDI ? billEvent.CFDI.conceptos : []);
                return (
                    <div className="billEventGroupper" key={i}>
                        {
                            !billEvent.NotaCreditoCFDI ?
                                '' :
                                <div>

                                    <h4>Nota de crédito para el adelanto</h4>
                                    <div className="card table">
                                        <div className="cardBody">
                                            <div className="_wrapNota">
                                                <PreviewConceptos conceptos={billEvent.NotaCreditoCFDI.conceptos} valorClassName="_valor _price" />
                                                <PreviewTotales totales={notaTotales} gateTotales={cfdiTotales} letraPrefix="Nota de crédito por " />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        {
                            !billEvent.CFDI ?
                                '' :
                                <div>
                                    <h4>Factura de liquidación completa</h4>
                                    <div className="card table">
                                        <div className="cardBody">
                                            <div className="_wrapCFDI">
                                                <PreviewConceptos conceptos={billEvent.CFDI.conceptos} />
                                                <PreviewTotales totales={cfdiTotales} showDescuento={true} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                )
            })}
        </>
    )
}

export default PreviewSecondaryBills;
